export default {
  name: 'planeSpin'
};